<template>
  <v-container>
    <div class="text-h6 pa-4 text-center">
      <span class="font-weight-bold">招待方法を選択してください</span><br />
      追加されたメンバーは、患者様の健康データの閲覧や予兆があった場合にアラートを受信できます。
      また、チャットグループに追加され、メッセージのやり取りが可能になります。
    </div>
    <div class="text-body-1 text-grey-darken-1"></div>

    <v-row>
      <!-- QRコードで招待 -->
      <v-col cols="12">
        <v-card
          class="pa-3 cursor-pointer"
          outlined
          @click="$router.push('/qr-invitation').catch(() => {})"
        >
          <v-row justify="space-between">
            <v-col>
              <div class="text-h5 font-weight-bold">QRコードで招待</div>
              <div class="text-body-1 text-grey-darken-1">
                招待したいメンバーのスマートフォンからQRコードを読み取ることで追加できます。
                <div class="absolute top-0 right-4 opacity-10">
                  <v-icon color="black" size="80px">mdi-qrcode </v-icon>
                </div>
              </div>
            </v-col>
            <v-icon>mdi-chevron-right</v-icon>
          </v-row>
        </v-card>
      </v-col>

      <!-- メールで招待 -->
      <v-col cols="12">
        <v-card
          class="pa-3 cursor-pointer"
          outlined
          @click="$router.push('/email-invitation').catch(() => {})"
        >
          <v-row justify="space-between">
            <v-col>
              <div class="text-h5 font-weight-bold">メールで招待</div>
              <div class="text-body-1 text-grey-darken-1">
                招待したいメンバーにメールで招待リンクを送信し、追加できます。
              </div>
              <div class="absolute top-0 right-4 opacity-10">
                <v-icon color="black" size="80px">mdi-email </v-icon>
              </div>
            </v-col>
            <v-icon>mdi-chevron-right</v-icon>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Invitation",
  data: () => ({}),
  methods: {},
};
</script>
